'use client';
import {
  AppleMapProps,
  MapCoordinate,
} from '@wt/shared/components/maps/mapkit/types';
import { Spinner } from '@wt/shared/components/spinner/spinner';
import {
  CoordinateRegion,
  Map,
  MapInteractionEvent,
  Marker,
} from '@wt/shared/libs/mapkit';
import { getSiteThemes } from '@wt/utilities/siteMode';
import { useEffect, useMemo, useRef, useState } from 'react';

export const MapElement = (props: AppleMapProps) => {
  const [marker, setMarker] = useState<MapCoordinate | null | undefined>(
    props.selectedLocation
  );
  const [marker2, setMarker2] = useState<MapCoordinate | null | undefined>(
    props.selectedLocationSecondary
  );

  const mapRef = useRef<mapkit.Map | null>(null);
  const loaderRef = useRef<HTMLDivElement | null>(null);
  const mapContainerRef = useRef<HTMLDivElement | null>(null);

  const handleSelect = (e: MapInteractionEvent) => {
    props.onLocationSelect && props.onLocationSelect(e);
  };

  useEffect(() => {
    setMarker(props.selectedLocation);
  }, [props.selectedLocation]);

  useEffect(() => {
    setMarker2(props.selectedLocationSecondary);
  }, [props.selectedLocationSecondary]);

  const centerCoordinate = (point: MapCoordinate, animate = true) => {
    const map = mapRef.current;
    if (map && point) {
      map.setCenterAnimated(
        new mapkit.Coordinate(point.latitude, point.longitude),
        animate
      );
    }
  };

  const mapLoaded = () => {
    if (marker) {
      centerCoordinate(marker, false);
    }
  };

  const handleMarkerChange = (marker: MapCoordinate | null | undefined) => {
    const spinner = loaderRef.current;
    const mapContainer = mapContainerRef.current;
    if (marker) {
      centerCoordinate(marker);
    }
    if (mapContainer && spinner) {
      if (mapContainer.style.opacity !== '1') {
        //alert('found');
        spinner.style.opacity = '0';
        mapContainer.style.opacity = '1';
      }
    }
  };

  useEffect(() => {
    handleMarkerChange(marker);
  }, [marker]);
  useEffect(() => {
    handleMarkerChange(marker2);
  }, [marker2]);
  useEffect(() => {
    if (props.currentPin === 0) {
      if (marker) centerCoordinate(marker);
    } else if (props.currentPin === 1) {
      if (marker2) centerCoordinate(marker2);
    }
  }, [props.currentPin]);

  // set inital region to show North America and Europe
  const initialRegion: CoordinateRegion = useMemo(() => {
    return {
      centerLatitude: 25,
      centerLongitude: -30,
      latitudeDelta: props.inModal ? 180 : 50,
      longitudeDelta: props.inModal ? 360 : 80,
    };
  }, [props.inModal]);

  return (
    <div className={`relative size-full ${props.className ?? ''}`}>
      <div
        ref={loaderRef}
        className="pointer-events-none absolute inset-0 flex flex-col items-center justify-center bg-[#230352] opacity-100 backdrop-blur-md transition-all duration-300 ease-in-out"
      >
        <Spinner />
      </div>
      <div ref={mapContainerRef} className="absolute inset-0 size-full ">
        <Map
          ref={mapRef}
          onLoad={mapLoaded}
          onSingleTap={handleSelect}
          initialRegion={initialRegion}
        >
          {marker && props.selectedLocation && (
            <Marker
              title={props.label ? props.label : 'Your Guess'}
              latitude={props.selectedLocation.latitude}
              longitude={props.selectedLocation.longitude}
              onSelect={() => {
                if (props.setCurrentPin) {
                  props.setCurrentPin(0);
                }
              }}
            />
          )}
          {marker2 && props.selectedLocationSecondary && (
            <Marker
              title={props.label ? props.label : 'Your Guess'}
              latitude={props.selectedLocationSecondary.latitude}
              longitude={props.selectedLocationSecondary.longitude}
              color={getSiteThemes().darkTheme.error}
              onSelect={() => {
                if (props.setCurrentPin) {
                  props.setCurrentPin(1);
                }
              }}
            />
          )}
        </Map>
      </div>
    </div>
  );
};

export default MapElement;
